import { render, staticRenderFns } from "./ProjectCustomer.vue?vue&type=template&id=114ecdfc"
import script from "./ProjectCustomer.vue?vue&type=script&lang=js"
export * from "./ProjectCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports